import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSubscription } from "../../context/SubscriptionContext";
import { Button } from "../common/Button";
import { UpgradeModal } from "./UpgradeModal";
import styles from "./UpgradeBanner.module.css";

export function UpgradeBanner() {
  const { isFree } = useSubscription();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!isFree || dismissed) return null;

  return (
    <div className={styles.banner}>
      <span>{t("dashboard.upgradeBanner")}</span>
      <div className={styles.actions}>
        <Button size="sm" onClick={() => setOpen(true)}>Upgrade</Button>
        <button className={styles.dismiss} onClick={() => setDismissed(true)} aria-label="Dismiss">✕</button>
      </div>
      <UpgradeModal open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
